import { NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { AuthSemMenuGuard } from './guards/auth-sem-menu.guard';
import { AuthGuard } from './guards/auth.guard';
import { basRoutes } from './routes/bas.routes';
import { cadRoutes } from './routes/cad.routes';
import { cmlRoutes } from './routes/cml.routes';
import { ctbRoutes } from './routes/ctb.routes';
import { finRoutes } from './routes/fin.routes';
import { recRoutes } from './routes/rec.routes';
import { praRoutes } from './routes/pra.routes';
import { fatRoutes } from './routes/fat.routes';
import { estRoutes } from './routes/est.routes';
import { indRoutes } from './routes/ind.routes';
import { cntRoutes } from './routes/cnt.routes';
import { serRoutes } from './routes/ser.routes';
import { environment } from 'src/environments/environment';
import { cliRoutes } from './routes/cli.routes';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.module').then(
            (module) => module.HomeModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'meu-usuario',
        loadChildren: () =>
          import('./pages/bas/usuario/usuario.module').then(
            (module) => module.UsuarioModule
          ),
        canActivate: [AuthSemMenuGuard],
      },

      { path: 'bas', children: basRoutes },
      { path: 'cad', children: cadRoutes },
      { path: 'cml', children: cmlRoutes },
      { path: 'cnt', children: cntRoutes },
      { path: 'ctb', children: ctbRoutes },
      { path: 'est', children: estRoutes },
      { path: 'fat', children: fatRoutes },
      { path: 'fin', children: finRoutes },
      { path: 'ind', children: indRoutes },
      { path: 'pra', children: praRoutes },
      { path: 'rec', children: recRoutes },
      { path: 'ser', children: serRoutes },
      { path: 'cli', children: cliRoutes },
    ],
  },
  {
    path: 'public',
    children: [
      {
        path: 'sign-in',
        loadChildren: () =>
          import('./pages/sign-in/sign-in.module').then(
            (module) => module.SignInModule
          ),
      },
      {
        path: 'nova-senha',
        loadChildren: () =>
          import('./pages/nova-senha/nova-senha.module').then(
            (module) => module.NovaSenhaModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, environment['debugRoutes'] ? {enableTracing: true} : {} )],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.errorHandler = (error: any) => {
      console.error(error);
      this.router.navigate(['/home']);
    };
  }
}
